import {ProductInterface} from "../../interfaces/product/ProductInterface";
import BrandInfo from "./BrandInfo";
import {ProductPropertyInterface} from "../../interfaces/product/ProductPropertyInterface";
import {ProductPropertyValueInterface} from "../../interfaces/product/ProductPropertyValueInterface";

export default function Specification({product, properties}: {product:ProductInterface, properties: ProductPropertyValueInterface[]}) {
    return (<div
        className="flex-column flex-lg-row gap-4  justify-content-between prod-pane active show"
        id="descript" role="tabpanel" aria-labelledby="descript-tab">
        <div className="d-flex flex-column prod-pane__left">
            <div className="prod-pane__text">
                <p className="fw-bold text-uppercase">Технические характеристики</p>

                {properties.map((property: ProductPropertyValueInterface) =>  <p key={property.id}>{property.name}: {property.value}</p> )}

            </div>
        </div>
        <BrandInfo product={product} />
    </div>)
}